// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"mPr71LF7BB2eJe1dOUsd","childContent":"Oi74EPcomrGY0IE4urLv"};